import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mtj_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const ORGAN_META = {
  kidney: { name: "Kidney", slug: "kidney" },
  liver: { name: "Liver", slug: "liver" },
  heart: { name: "Heart", slug: "heart" },
  lung: { name: "Lung", slug: "lung" },
  pancreas: { name: "Pancreas", slug: "pancreas" },
  intestine: { name: "Intestine", slug: "intestine" },
};

export const JOURNEY_TYPES = [
  { value: "recipient", label: "Recipient" },
  { value: "living_donor", label: "Living donor" },
  { value: "family_member", label: "Family member" },
  { value: "caregiver", label: "Caregiver" },
  { value: "evaluation_patient", label: "Someone undergoing evaluation" },
  { value: "other", label: "Other" },
];

export const JOURNEY_STAGES = [
  { value: "evaluation", label: "Evaluation" },
  { value: "waiting", label: "Waiting" },
  { value: "transplant_completed", label: "Transplant completed" },
  { value: "post_transplant", label: "Post transplant" },
  { value: "transplant_postponed", label: "Transplant postponed" },
  { value: "transplant_cancelled", label: "Transplant cancelled" },
  { value: "decided_not_to_proceed", label: "Decided not to proceed" },
  { value: "other", label: "Other" },
];

export const LANGUAGES = ["English", "Hindi", "Gujarati"];

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
